import React, { useState, useEffect, useCallback } from 'react';
import { RadioGroup, Radio } from '@this/shared/ui/inputs/radio';
import { Title } from '../god';
import ForeignRegionsTab from './foreign_regions_tab';
import CountriesTab from './countries_tab';
import DomesticAirlinesTab from './domestic_airlines_tab';

function getStyles() {
  return {
    content: {
      padding: '20px'
    } as React.CSSProperties,
    selectTab: {
      display: 'flex',
      marginBottom: '20px'
    } as React.CSSProperties,
    label: {
      marginRight: '20px',
      cursor: 'pointer'
    } as React.CSSProperties
  } as const;
}

const Tab = {
  foreign_regions: '海外地域',
  countries: '国',
  domestic_airlines: '国内航空会社'
} as const;

type TabType = keyof typeof Tab;

const Master: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<TabType>(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab') as TabType;
    return tab && Tab[tab] ? tab : 'foreign_regions';
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('tab', currentTab);
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.replaceState({}, '', newUrl);
    document.title = `${Tab[currentTab]} - マスタ管理`;
    return () => {
      document.title = 'GOD管理画面';
    };
  }, [currentTab]);

  const handleTabChange = useCallback((tab: TabType) => {
    setCurrentTab(tab);
  }, []);

  const styles = getStyles();

  return (
    <div>
      <Title>マスタ管理</Title>
      <div style={styles.content}>
        <div style={styles.selectTab}>
          <RadioGroup
            layout="horizontal"
            value={currentTab}
            onChange={e => handleTabChange(e.target.value as TabType)}
          >
            {(Object.keys(Tab) as TabType[]).map(tab => (
              <Radio key={tab} value={tab}>
                {Tab[tab]}
              </Radio>
            ))}
          </RadioGroup>
        </div>
        {currentTab === 'foreign_regions' && <ForeignRegionsTab />}
        {currentTab === 'countries' && <CountriesTab />}
        {currentTab === 'domestic_airlines' && <DomesticAirlinesTab />}
      </div>
    </div>
  );
};

export default Master;
